// Word-boundary matches: ROOKIE and AUTO. Safe against "CGC AUTH" grading designations.
const META_RULES = [
    ['rookie', /\bROOKIE\b/i],
    ['autographed', /\bAUTO\b/i],
];

/**
 * Derives cardMeta.rookie and cardMeta.autographed from the card title.
 * Fill-gaps policy: only sets a field when it is not already explicitly present.
 */
export const deriveCardMeta = (cards) => {
    if (!Array.isArray(cards)) return;

    for (const card of cards) {
        if (!card || typeof card.title !== 'string') continue;

        if (!card.cardMeta) card.cardMeta = {};

        for (const [key, re] of META_RULES) {
            if (card.cardMeta[key] == null) card.cardMeta[key] = re.test(card.title);
        }
    }
};
